/* eslint-disable no-param-reassign */
const formatCurrency = (value, blankValue = '-') => {
  if (!value) {
    return blankValue;
  }
  try {
    value = Number(value);
  } catch (e) {
    return blankValue;
  }
  const currency = Number(value.toFixed(2)).toLocaleString('zh');
  // eslint-disable-next-line prefer-const
  let [int, float] = currency.split('.');
  if (!float || float.length < 2) {
    float = (float || '').padEnd(2, '0');
  }
  return `${int}.${float}`;
};
const formatRate = (value, blankValue = '-') => {
  if (!value) {
    return blankValue;
  }
  try {
    value = Number(value);
  } catch (e) {
    return blankValue;
  }
  const rate = value.toFixed(2);
  // eslint-disable-next-line prefer-const
  let [int, float] = rate.split('.');
  if (!float || float.length < 2) {
    float = (float || '').padEnd(2, '0');
  }
  return `${int}.${float}`;
};
export default { formatCurrency, formatRate };
